// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1QQTA","title":"FrontImage_title__2TsjA"};